import { customerTypeEnum } from "../enums/customerType.enum";

export function getCustomerIcon(customerType: customerTypeEnum | string, isDirectCustomer?: boolean, isArchived: boolean = false): string {
  const isCompany = customerType === customerTypeEnum.COMPANY;
  if (isArchived) return isCompany ? "ArchivedCompany" : "ArchivedPerson";
  if (isDirectCustomer) return isCompany ? "BuildingFill" : "UserFill";
  return isCompany ? "LinkedCompany" : "LinkedPerson";
}

export function getCustomerIconTooltip(isDirectCustomer?: boolean, isArchived: boolean = false): string {
  if (isArchived) {
    return isDirectCustomer ? "customer-list.Icon_Tooltip_Archived_Customer" : "customer-list.Icon_Tooltip_Archived_Linked_Relation";
  }
  return isDirectCustomer ? "customer-list.Icon_Tooltip_Customer" : "customer-list.Icon_Tooltip_Linked_Relation";
}
